// Generated by purs version 0.13.8
"use strict";
var Data_Symbol = require("../Data.Symbol/index.js");
var Lunarbox_Data_Dataflow_Type = require("../Lunarbox.Data.Dataflow.Type/index.js");
var Type_Proxy = require("../Type.Proxy/index.js");
var Typeable = function ($$typeof) {
    this["typeof"] = $$typeof;
};
var $$typeof = function (dict) {
    return dict["typeof"];
};
var typeableSymbol = function (dictIsSymbol) {
    return new Typeable(function (v) {
        return Lunarbox_Data_Dataflow_Type.TVariable.create(true)(Lunarbox_Data_Dataflow_Type.TVarName(Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value)));
    });
};
var typeableString = new Typeable(function (v) {
    return Lunarbox_Data_Dataflow_Type.typeString;
});
var typeableNumber = new Typeable(function (v) {
    return Lunarbox_Data_Dataflow_Type.typeNumber;
});
var typeableInt = new Typeable(function (v) {
    return Lunarbox_Data_Dataflow_Type.typeNumber;
});
var typeableBool = new Typeable(function (v) {
    return Lunarbox_Data_Dataflow_Type.typeBool;
});
var typeableArrow = function (dictTypeable) {
    return function (dictTypeable1) {
        return new Typeable(function (v) {
            return Lunarbox_Data_Dataflow_Type.typeFunction($$typeof(dictTypeable)(Type_Proxy["Proxy"].value))($$typeof(dictTypeable1)(Type_Proxy["Proxy"].value));
        });
    };
};
var typeableArray = function (dictTypeable) {
    return new Typeable(function (v) {
        return Lunarbox_Data_Dataflow_Type.typeArray($$typeof(dictTypeable)(Type_Proxy["Proxy"].value));
    });
};
var typePair = function (dictTypeable) {
    return function (dictTypeable1) {
        return new Typeable(function (v) {
            return Lunarbox_Data_Dataflow_Type.typePair($$typeof(dictTypeable)(Type_Proxy["Proxy"].value))($$typeof(dictTypeable1)(Type_Proxy["Proxy"].value));
        });
    };
};
var getType = function (dictTypeable) {
    return function (v) {
        return $$typeof(dictTypeable)(Type_Proxy["Proxy"].value);
    };
};
module.exports = {
    "typeof": $$typeof,
    Typeable: Typeable,
    getType: getType,
    typeableNumber: typeableNumber,
    typeableInt: typeableInt,
    typeableString: typeableString,
    typeableBool: typeableBool,
    typeableArray: typeableArray,
    typePair: typePair,
    typeableSymbol: typeableSymbol,
    typeableArrow: typeableArrow
};
